export const iconFontAwesomeEnergyFireFlameSimple = (
	<i className="fa-solid fa-fire-flame-simple"></i>
);
